/*!
 * Adapted from jQuery UI core
 * Taken from https://github.com/reactjs/react-modal/blob/master/src/helpers/tabbable.js
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

const tabbableNode = /input|select|textarea|button|object/;

export function hidesContents(element) {
  const zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  const style = window.getComputedStyle(element);
  const isDisplayNone = style.getPropertyValue('display') === 'none';

  if (isDisplayNone) return true;

  return zeroSize
    ? style.getPropertyValue('overflow') !== 'visible'
    : isDisplayNone;
}

export function visible(element) {
  let parentElement = element;

  while (parentElement) {
    if (parentElement === document.body) break;

    if (hidesContents(parentElement)) return false;

    parentElement = parentElement.parentNode;
  }

  return true;
}

export function focusable(element, isTabIndexNotNaN) {
  const nodeName = element.nodeName.toLowerCase();
  const res = (tabbableNode.test(nodeName) && !element.disabled)
    || (nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);

  return res && visible(element);
}

export function tabbable(element) {
  let tabIndex = element.getAttribute('tabindex');

  if (tabIndex === null) tabIndex = undefined;

  const isTabIndexNaN = isNaN(tabIndex);// eslint-disable-line no-restricted-globals

  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

export default function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(tabbable);
}

export function findTabbableBoundaries(element) {
  const focusableEls = findTabbableDescendants(element);

  if (!focusableEls.length) {
    return null;
  }

  return {
    first: focusableEls[0],
    last: focusableEls[focusableEls.length - 1],
  };
}
